var styles = {"box":"AuthSlider_box_1ybrq_1","controls":"AuthSlider_controls_1ybrq_1","controls__inner":"AuthSlider_controls__inner_1ybrq_8","bullet":"AuthSlider_bullet_1ybrq_18","overflow":"AuthSlider_overflow_1ybrq_30"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
